export const CphResource = {
    filter_lbl: "Filters",
    reset_lbl: "Reset",
    no_results_lbl: "No issues found.",
    no_comments_lbl: "No comments have been submitted yet.",
};